import { useState } from "react";
import { Link, useNavigate, useRouteLoaderData, useSubmit } from "react-router-dom";
import UserInfo from "src/components/common/userInfo";
import { getDateEndFromWeekNum, getDatefromWeekNum, myAxios, standbyWeeks, weekDays } from "src/components/common/functions";
import { StandbyWeekData } from "./actions_loaders";

type LoaderData = {
    week: string;
    form: StandbyWeekData;
    selectedUser: {
        id: string;
        email: string;
        userName: string;
        lanId?: string;
    };
};

export default function AllStandbyDetail() {
    const { week, form, selectedUser } = useRouteLoaderData("AllStandbyDetail") as LoaderData;
    const navigate = useNavigate();
    const submit = useSubmit();
    const [switchWeek, setSwitchWeek] = useState("");

    const openExcel = async (fileId: string, fileName: string) => {
        const formData = new FormData();
        formData.append("fileId", fileId);
        const res = await myAxios({ fileName: "outside/standby/getExcel.php", formData });
        if (!res?.data) return;
        const anchor = document.createElement("a");
        anchor.href = String(res.data);
        anchor.download = fileName;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        anchor.click();
    };

    const handleSwitchWeek = () => {
        if (!switchWeek) {
            window.alert("Select a target week first.");
            return;
        }
        const formData = new FormData();
        formData.append("toWk", switchWeek);
        submit(formData, { method: "post", action: "SwitchWeek" });
    };

    return (
        <div className = "pb8rem px-3">
            <nav className = "d-flex align-items-center justify-content-between flex-wrap gap-3 mt-3">
                <span>Standby Status</span>
                <button type = "button" className = "btn btn-outline-primary" onClick = {() => navigate(`/OutsideStatusStandby/${week}`)}>Back</button>
            </nav>

            <div className = "my-3 border rounded bg-white p-3">
                <div className = "d-flex flex-wrap gap-4">
                    <div>
                        <div className = "small text-muted fw-bold">Employee</div>
                        <UserInfo name = {selectedUser.userName} id = {selectedUser.id || selectedUser.email} />
                    </div>
                    <div>
                        <div className = "small text-muted fw-bold">Week</div>
                        <div>{getDateEndFromWeekNum(week)}</div>
                    </div>
                    <div>
                        <div className = "small text-muted fw-bold">Status</div>
                        <div>{form.status || "Created"}</div>
                    </div>
                    <div>
                        <div className = "small text-muted fw-bold">Region</div>
                        <div>{form.region || "N/A"}</div>
                    </div>
                </div>
            </div>

            <div className = "mb-3 d-flex flex-wrap gap-2">
                {(form.id || form.billableId) ? (
                    <>
                        {form.id ? <button type = "button" className = "btn btn-primary" onClick = {() => openExcel(String(form.id), `${week}.xlsx`)}>Payroll</button> : null}
                        {form.billableId ? <button type = "button" className = "btn btn-success" onClick = {() => openExcel(String(form.billableId), `${week} billable.xlsx`)}>Billable</button> : null}
                    </>
                ) : null}
                <select className = "form-control inline" style = {{ maxWidth: 180 }} value = {switchWeek} onChange = {e => setSwitchWeek(e.currentTarget.value)}>
                    <option value = "">Switch To Week</option>
                    {standbyWeeks.filter(value => value !== week).map((value, index) => (
                        <option key = {index} value = {value}>{getDateEndFromWeekNum(value)}</option>
                    ))}
                </select>
                <button type = "button" className = "btn btn-outline-primary" onClick = {handleSwitchWeek}>Switch Week</button>
            </div>

            <div className = "table-responsive mb-4">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Day</th>
                            <th>Date</th>
                            <th>Entries</th>
                            <th>Categories</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(form.data ?? []).map((day: any, index: number) => {
                            const jobs = Array.isArray(day) ? day.slice(1).filter((job: any) => job?.category) : [];
                            return (
                                <tr key = {index}>
                                    <td>{weekDays[index]}</td>
                                    <td>{getDatefromWeekNum(week, index)}</td>
                                    <td>{jobs.length}</td>
                                    <td>{jobs.map((job: any) => job.category).join(", ") || "None"}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className = "mb-3">
                <div className = "small text-muted fw-bold mb-1">Other Notes</div>
                <div className = "border rounded p-3 bg-white" style = {{ whiteSpace: "pre-wrap" }}>
                    {form.otherNotes || "None"}
                </div>
            </div>

            <div className = "mb-3">
                <Link className = "btn btn-outline-primary" to = "Edit">Edit</Link>
            </div>
        </div>
    );
}
